<div class="col-12 no-pd upload-doc">
  <div class="row">
    <div class="col">
      <form class="row" [formGroup]="formUpload">
        @if (canUpload) {
          <div class="col-md-6 upload-doc-left-col">
            <div class="col-12">
              <p class="info-text" [innerHTML]="'documentation.info_' + type | translate"></p>

              <input
                #inputFile
                hidden
                id="inputFile"
                type="file"
                enctype="multipart/form-data"
                [accept]="supportedFiles"
                (change)="uploadImg($event)"
              />

              @if (formUpload.controls['file'].touched && !formUpload.controls['file'].valid) {
                <p id="msg-error-file" class="has-error text-center">
                  {{ 'upload_file_error_required_file' | translate }}
                </p>
              }

              @if (errorFile?.hasError) {
                <p id="msg-error-file" class="text-center">
                  {{ errorFile?.msgError }}
                </p>
              }

              @if (fileUpload && !fileUpload?.icon) {
                <div class="col-12">
                  <div class="file-list">
                    <h3
                      for="upload-file-file"
                      [class.has-error]="formUpload.controls['file'].touched && !formUpload.controls['file'].valid"
                    ></h3>
                    <img class="img-upload" [src]="fileUpload.icon" />
                    <span class="file-name text-center"> {{ fileUpload.name }} - </span>
                    <span class="file-size text-center">
                      {{ fileUpload.size | fileSize: '1' }}
                    </span>
                  </div>
                </div>
              }

              @if (fileUpload && fileUpload?.icon) {
                <div class="col-12 upload-btn-group">
                  <textarea
                    id="upload-file-description"
                    rows="2"
                    formControlName="documentDesc"
                    maxlength="200"
                    [placeholder]="'modal_upload_file_comment_placeholder' | translate"
                  >
                  </textarea>

                  @if (
                    formUpload.controls['documentDesc'].touched &&
                    formUpload.controls['documentDesc'].hasError('required')
                  ) {
                    <p id="msg-error-file" class="text-center">
                      {{ 'upload_file_description_required' | translate }}
                    </p>
                  }
                </div>
              }

              <div class="row upload-btn-group">
                @if (!resizing) {
                  <button
                    id="upload-file-btn-attach-file"
                    class="btn upload-btn"
                    [ngClass]="{
                      'btn-02': !fileUpload?.icon,
                      'btn-01': fileUpload && fileUpload?.icon,
                    }"
                    (click)="inputFile.click()"
                  >
                    +
                    @if (!fileUpload?.icon) {
                      <span>{{ 'upload_file_btn_attach_file' | translate }}</span>
                    }
                    @if (fileUpload && fileUpload?.icon) {
                      <span>{{ 'upload_file_change_attach' | translate }}</span>
                    }
                  </button>
                }

                @if (resizing) {
                  <button id="upload-file-btn-attach-file" class="btn upload-btn btn-01">
                    <span>{{ 'modal_upload_file_loading' | translate }}</span>
                  </button>
                }

                @if (fileUpload && fileUpload?.icon) {
                  <button class="btn btn-02" type="submit" id="upload-file-btn-upload" (click)="finishUpload()">
                    {{ 'upload_file_send' | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
        }

        @if (!canUpload) {
          <div class="col-md-6 upload-doc-left-col">
            <!-- <p>El documento <span>{{ ('documentation.name_' + type) | translate }}</span> ya está validado por tu Gestor Pibank.</p> -->
            <p
              [innerHTML]="
                'upload_file_documentation_validated' | translate: { type: 'documentation.name_' + type | translate }
              "
            ></p>
            <p>{{ 'upload_file_cant_upload' | translate }}</p>
          </div>
        }

        @if (!itemSelected && !filesNotType) {
          <div class="col-md-6">
            <h3 class="h-main h-main-medium col-12">
              {{ 'upload_file_document_upload' | translate }}
            </h3>
            <div class="row files-list-header">
              <div class="col-4 no-pd">
                <p>{{ 'upload_file_file' | translate }}</p>
              </div>
              <div class="col-6">
                <p>{{ 'upload_file_status' | translate }}</p>
              </div>

              <div class="col-2 no-pd">
                <!-- <p>{{ 'upload_file_delete' | translate }} </p> -->
              </div>
            </div>

            <div class="row files-list-items" *ngFor="let document of listDocuments">
              <div class="col-4 no-pd">
                <p class="file-name">{{ document.name }}</p>
              </div>
              <div class="col-6">
                <p
                  [ngClass]="{
                    observations: document.state === 'REVIEW_DOC_PENDING',

                    revision: document.state === 'NOT_VALID_DOC',
                    success: document.state === 'VALIDATED_DOC',
                  }"
                >
                  {{ document.state | translate }}
                </p>
                <p *ngFor="let reason of document.rejectReasons" class="observations">
                  {{ reason }}
                </p>
              </div>
              <div class="col-2 content-actions-file">
                <!-- <span class="fa fa-close delete-icon" *ngIf="document.state === 'REVIEW_DOC_PENDING' && status === ALL_STATUS.attachDocumentation" (click)="showConfirmDelete(document)"></span> -->
                @if (document.state === 'REVIEW_DOC_PENDING' && status === ALL_STATUS.attachDocumentation) {
                  <img
                    class="icon-delete"
                    title="Borrar fichero"
                    id="upload-file-btn-delete-file"
                    src="./assets/img/icono-borrar.svg"
                    (click)="showConfirmDelete(document)"
                  />
                }

                @if (!document['downloading']) {
                  <img
                    class="icon-download"
                    title="Descargar fichero"
                    id="upload-file-btn-download"
                    src="./assets/img/descargar.svg"
                    id="upload-file-btn-download"
                    src="./assets/img/descargar.svg"
                    (click)="downloadFile(document)"
                  />
                } @else {
                  <img class="icon-download" title="Descargando fichero" src="./assets/img/loading-descarga.svg" />
                }
              </div>
              <div class="col-10 no-pd">
                <p class="observations">{{ document.description }}</p>
              </div>
            </div>

            @if (loading) {
              <div class="row files-list-items loading">
                <div class="col-4"><p></p></div>
                <div class="col-6"><p></p></div>
                <div class="col-2"><p></p></div>
                <div class="col-4"><p></p></div>
                <div class="col-6"><p></p></div>
                <div class="col-2"><p></p></div>
                <div class="col-4"><p></p></div>
                <div class="col-6"><p></p></div>
                <div class="col-2"><p></p></div>
              </div>
            }
          </div>
        }

        @if (itemSelected) {
          <div class="col-md-6 delete-file">
            <p>{{ 'upload_file_file_to_delete' | translate }}</p>
            <p class="deleted-file-name">{{ itemSelected?.name }}</p>
            <p>{{ 'upload_file_are_you_sure' | translate }}</p>
            <div class="content-btn-confirm">
              <button class="btn btn-01 btn-small" id="upload-file-btn-delete" (click)="itemSelected = null">
                {{ 'no' | translate }}
              </button>
              <button
                class="btn btn-02 btn-small"
                id="upload-file-btn-delete"
                (click)="deleteFile(itemSelected.fileId)"
              >
                {{ 'yes' | translate }}
              </button>
            </div>
          </div>
        }

        @if (filesNotType) {
          <div class="col-md-6">
            <h3 class="h-main h-main-medium col-12">
              {{ 'upload_file_document_upload' | translate }}
            </h3>
            <div class="row files-list-header">
              <div class="col-8 no-pd">
                <p>{{ 'upload_file_file' | translate }}</p>
              </div>
              <div class="col-3">
                <p>{{ 'upload_file_date' | translate }}</p>
              </div>
              <div class="col-1 no-pd"></div>
            </div>
            <div class="row files-list-items" *ngFor="let document of listDocuments">
              <div class="col-8 no-pd">
                <p class="file-name">{{ document.name }}</p>
              </div>
              <div class="col-3 text-right">
                <p class="date text-right">
                  <span>{{ document.timeUpload | date: 'dd/MM/yyyy' }}</span>
                </p>
              </div>
              <div class="col-1 no-pd content-actions-file">
                @if (!document['downloading']) {
                  <img
                    class="icon-download"
                    title="Descargar fichero"
                    id="upload-file-btn-download"
                    src="./assets/img/descargar.svg"
                    id="upload-file-btn-download"
                    src="./assets/img/descargar.svg"
                    (click)="downloadFile(document)"
                  />
                } @else {
                  <img class="icon-download" title="Descargando fichero" src="./assets/img/loading-descarga.svg" />
                }
              </div>
              <div class="col-12 no-pd">
                <p class="observations">{{ document.description }}</p>
                <!-- <span id="upload-file-btn-download" class="fa fa-close delete-icon" (click)="downloadFile(document.fileId)"></span> -->
              </div>
            </div>
            @if (loading) {
              <div class="row files-list-items loading">
                <div class="col-6"><p></p></div>
                <div class="col-4"><p></p></div>
                <div class="col-2"><p></p></div>
                <div class="col-12"><p></p></div>
                <div class="col-6"><p></p></div>
                <div class="col-4"><p></p></div>
                <div class="col-2"><p></p></div>
                <div class="col-12"><p></p></div>
                <div class="col-6"><p></p></div>
                <div class="col-4"><p></p></div>
                <div class="col-2"><p></p></div>
                <div class="col-12"><p></p></div>
              </div>
            }
          </div>
        }
      </form>
    </div>
  </div>

  @if (showError) {
    <p id="msg-error-file" class="has-error text-center">
      {{ 'upload_file_error_server' | translate }}
    </p>
  }

  <div class="row info-about-document">
    <p class="info-text info-text-secondary">
      {{ 'upload_file_format_files' | translate }}
    </p>
  </div>
</div>
